module.exports = __webpack_public_path__ + "img/third-onboarding-1.3463e139.png";